(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gravur-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gf-question');
    if (!btn) return;
    var item = btn.closest('.gf-item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
